import {
  getReviewableStatisticsUrl,
  getReviewCycleByIdUrl,
  getReviewCycleUrl,
  getReviewsUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class ReviewService {
  static getCycles = () => {
    return getRequest(getReviewCycleUrl());
  };

  static createOrUpdateReviewCycle = (
    cycle,
    courseIds,
    reflectionTemplateId
  ) => {
    const params = {};
    if (cycle.id) {
      params.reviewCycleId = cycle.id;
    }
    if (reflectionTemplateId !== "-1") {
      params.templateId = reflectionTemplateId;
    }
    params.reviewCycle = cycle;
    params.courseIds = courseIds;
    return postRequest(getReviewCycleUrl(), params);
  };

  static getReviewsByContextId = (contextId) => {
    return getRequest(getReviewsUrl(), { reviewableId: contextId });
  };

  static upsertReview = (review) => {
    const params = { review: review };
    return putRequest(getReviewsUrl(), params);
  };

  static getReviewFolderPath(cycleId, reviewableId, reviewId) {
    return `${cycleId}/${reviewableId}/${reviewId}`;
  }
  static deleteReviewCycle = (cycleId) => {
    return deleteRequest(getReviewCycleByIdUrl(cycleId));
  };

  static getReviewStatistics(reviewId) {
    const params = { reviewId };
    return getRequest(getReviewableStatisticsUrl(), params);
  }
}
